import React from "react";
import "./Oders.scss";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Header from "../Home/HomeMain/Header/Header";

const Oders = () => {
  const navigate = useNavigate();

  return (
    <div className="order_main">
      <div className="Order_detail_main_div">
        {Array.from({ length: 15 }, (_, index) => (
          <Button
            key={index}
            className="OrderPage_deatil_div"
            onClick={() => navigate("/OdersDetail")}
          >
            <div className="cateloging_sub_div">
              <div style={{ display: "flex" }}>
                <img
                  src="https://giftolexia.com/wp-content/uploads/2015/11/dummy-profile.png"
                  className="catelogin_Deatil_img"
                  alt="Profile"
                />
              </div>
              <div>
                <p className="catelog_name">Mohan Sharma</p>
                <p className="catelog_email">Sharma@gmail.com</p>
                <p className="catelog_time">2 months ago</p>
              </div>
            </div>
            <div className="catelog_item_div">
              <p className="ctelog_itemCount">2 Items</p>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default Oders;